
































































import { Mixins, Component, Prop, Vue } from "vue-property-decorator";
import { EditorItemMixin, CommentReferenceMixin } from "./mixins";
import { ReceptionDetail } from "../../../../domain/workflow/reception";
import { ProgressConditionKinds, ReceptionEditKinds } from "../../../../domain/workflow/kinds";

import { ModelEditableMixin } from "../../../system/mixins";

import ReceptionDialogSelector from "../../selectors/ReceptionDialogSelector.vue";

import ReceptionDetailCommentsEditor from "./ReceptionDetailCommentsEditor.vue";
import ReceptionDetailDepartmentEditor from "./ReceptionDetailDepartmentEditor.vue";
import ReceptionDetailManagerEditor from "./ReceptionDetailManagerEditor.vue";
import { User } from "../../../../domain/user";
import { Department } from "../../../../domain/department";
import { RoutePatternSelectorDialog } from "../../dialogs";
import { WorkflowPhaseEditorModel } from "../../../../domain/workflow/editor";
import WorkflowPhaseEditor from "./WorkflowPhaseEditor.vue";

@Component({
  components: {
    ReceptionDetailDepartmentEditor,
    ReceptionDetailManagerEditor,
    ReceptionDetailCommentsEditor,
    ReceptionDialogSelector,
    WorkflowPhaseEditor,
  }
})
export default class CommonReceptionDetailEditor extends Mixins(ModelEditableMixin, EditorItemMixin, CommentReferenceMixin) {
  writePropertyWhenValid: (writer: (source: ReceptionDetail) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ReceptionDetail) => T, defaultValue: T) => T;

  @Prop()
  mode: ReceptionEditKinds;

  @Prop()
  receptionDate: Date;

  @Prop()
  commentLabel: string;

  @Prop({ default: false })
  isCommentEnable: boolean;

  @Prop()
  restrictCommentLabel: string;

  @Prop({ default: false })
  isRestrictCommentEnable: boolean;

  @Prop()
  nextMessageLabel: string;

  @Prop({ default: false })
  isNextMessageEnable: boolean;

  @Prop()
  isDepartmentEnable: boolean;

  @Prop()
  nonDisplayDepartmentCodes: string[];

  @Prop()
  isManagerEnable: boolean;

  @Prop()
  isPhaseEnable: boolean;

  @Prop()
  isWorkflowPhasesQuoteEnable: boolean;

  @Prop()
  hasSelectableRoutePattern: boolean;

  @Prop()
  allUser: User[];

  @Prop()
  displayProgressConditionKinds: ProgressConditionKinds[];

  @Prop()
  shouldSelectManagers: boolean;

  @Prop()
  routePatternSelectDialog: RoutePatternSelectorDialog;

  @Prop()
  shouldShowManagerPhoneNumber: boolean;

  managerEditor: ReceptionDetailManagerEditor;

  mounted(): void {
    // $refsはリアクティブではない模様.マウント後に初期化.
    this.managerEditor = this.$refs.managerEditor as ReceptionDetailManagerEditor;

  }

  get phases(): WorkflowPhaseEditorModel[] {
    return this.readPropertyOrDefault(d => d.route.phases, []);
  }

  set phases(values: WorkflowPhaseEditorModel[]) {
    this.writePropertyWhenValid(d => d.route.phases = values ? values : []);
  }

  get isRegistered(): boolean {
    return (this.mode === ReceptionEditKinds.Edit)
        && this.readPropertyOrDefault(s => !!s.id, false);
  }

  get detailDepartment(): Department {
    return this.isDepartmentEnable
      ? this.readPropertyOrDefault(d => d.department, null)
      : null;
  }

  get shouldKeepPhases(): boolean {
    return this.isWorkflowPhasesQuoteEnable
      && !!this.readPropertyOrDefault(d => d.sourceReceptionDetailId as number, null)
      && !this.readPropertyOrDefault(d => d.quoted as boolean, false);
  }

  get phasesDescription(): string {
    return this.shouldKeepPhases
      ? "引用文書なので自動では更新しません。"
      : "";
  }

  // 子コンポーネント（進捗パターン）からの更新を受信
  updatePhase(index: number, phase: WorkflowPhaseEditorModel) {
    const clone = this.editingSource.clone();
    clone.route.phases.splice(index, 1, phase);
    this.phases = clone.route.phases;
  }

  // 子コンポーネント（進捗パターンの連動選択）,または親コンポーネント（受付日の連動選択）の更新を受信
  updatePhaseDate(index: number, diffDays: number): void {
    if (!this.phases) { return; }

    // 受付日の連動選択を契機とする処理の場合は、この直前にbaseDateが更新されている。
    // 進捗に締切日数が指定されているときはbaseDateのWatchを契機として自動計算した締切日をセットする処理があり、
    // 何も対策しない場合は上記の自動計算された締切日により上書きされて、連動した日付とならない。
    // 連動選択の機能としては日付が連動されてほしいため、フラグによるガード処理を追加して対策している
    this.phases.forEach((p, i) => {
      const refs = this.$refs.phaseEditor as Vue[];
      if (!refs) { return; }
      const phaseEditor = (refs[i] as WorkflowPhaseEditor);
      if (!phaseEditor) { return; }
      phaseEditor.setLinkedDateUpdating();
    });
    
    // 連動選択による日付入力を行った進捗以降の締切日を自動で伸ばす
    this.phases.forEach((p, i) => {
      if (i < index || !p.limitDate) { return; }
      const limitDate = new Date(p.limitDate);
      limitDate.setDate(limitDate.getDate() + diffDays);
      const refs = this.$refs.phaseEditor as Vue[];
      if (!refs || refs.length < i) { return; }
      (refs[i] as WorkflowPhaseEditor).setLimitDate(limitDate);
    });
  }

  async showCommentDialogWithCommentTab(source: string, title: string, write: (text: string) => void): Promise<void> {
    this.showCommentDialogWithReferenceComment(source, title, write, this.editingSource, this.isRegistered);
  }

  async launchManagerSelectorAutomatically(): Promise<void> {
    // 対応責任者と診療科が受付単位単位で入力時にのみ有効
    if (this.shouldSelectManagers && this.isDepartmentEnable && this.isManagerEnable) {
      await this.$nextTick();
      this.managerEditor.selectManagers();
    }
  }

  async selectRoutePattern(): Promise<void> {
    const route = await this.routePatternSelectDialog.selectOption();
    if (!route) { return; }
    this.phases = route.phases;
  }
}
